import { 
  Autocomplete, Box, Paper, 
  Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, TextField,
  Checkbox, Typography, FormControlLabel,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from 'src/shared/grid';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {  ValidCharacters, isValidDate, validateCharacters } from 'src/store/common';
import moment from 'moment-timezone';
import CustomTablePagination from 'src/shared/TablePagination/CustomTablePagination';
import { useStoreContext } from 'src/store/context';
import { useAddAlert } from 'src/store/actions';
import { alertMessages, catalogEntityTypeForAudit } from 'src/constants';
import { getAuditItemsFromClim } from 'src/apis/getCatalogCalls';
import LoadingSpinner from 'src/shared/loading/loading';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocation } from 'react-router-dom';
import { getAccessTokenCookie } from 'src/shared/Login';
type AuditCatalogProps = {
  catalogType: any
};

export const AuditCatalog: React.FC<AuditCatalogProps> = ({ catalogType }) => {
  const [startDate, setStartDate] = useState<any>(moment('2000-01-01').utc().toDate());
  const [endDate, setEndDate] = useState<any>(moment().utc().toDate());
  const [errorStartDate, setErrorStartDate] = useState<string | null>(null)
  const [errorEndDate, setErrorEndDate] = useState<string | null>(null);

  const [activityType, setActivityType] = useState<string>("All");
  const [allActivityType] = useState(["All", "Delete", "New", "Update"]);

  const [allActivityChecked, setAllActivityChecked] =useState<boolean>(true);
  const [disabledStartDate, setDisabledStartDate] = useState<boolean>(true);
  
  const [entityType] = useState<any>(catalogEntityTypeForAudit.find((type)=>type.uiName ===catalogType));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  
  const [auditItems, setAuditItems] = useState<any[]>([])
  const [callAuditComplete, setCallAuditComplete] = useState(false);
  const [message, setMessage ] = useState('');

  const location = useLocation(); 
  

  const getAuditLogsCall = useCallback(() => {
    setCallAuditComplete(false);
    (async () => {
      try {
        const stringArray = decodeURIComponent(location?.pathname).split("/");
        const varRequest ={
          activityStartDate: moment(startDate).subtract(1, 'days').utc().format('YYYY-MM-DD'), 
          activityEndDate: moment(endDate).add(1, 'days').utc().format('YYYY-MM-DD'), 
          auditField: null, 
          auditTrailItemId: null, 
          auditType: activityType==='All'? null: activityType, 
          entityId: Number(stringArray[5]), 
          entityType: entityType.dbName, 
          sortBy: 'created_time', 
          sortOrder: 'DESC', 
          page: page, 
          perPage: rowsPerPage,
        }
        const response: any = await getAuditItemsFromClim(varRequest, addAlert);
        setTotalCount(response._metadata.total_count)
        setAuditItems(response.data);
        setCallAuditComplete(true);
        setMessage('')
        if(response?.data?.length<1){
          setMessage('No Audit Data Available for the Selected Activity Date Range and Type')
        }
      }
      catch (error) {
        console.log('error', error);
        setMessage('Data could not be retrieved. Please try again.')
        setCallAuditComplete(true);
        addAlert({
          id: '',
          message: alertMessages.getAuditLog,
          type: 'error-info',
          icon: 'fa-exclamation-triangle'
        })
      }
    })();
  }, [addAlert, setCallAuditComplete,location?.pathname, startDate, endDate, activityType, entityType, page, rowsPerPage]);

  const iconType = (type: string) => {
    if (type.toLowerCase().includes('new')) {
      return (<LibraryAddOutlinedIcon />)
    }
    else if (type.toLowerCase().includes('update')) {
      return (<EditNoteOutlinedIcon />)
    }
    else if(type.toLowerCase().includes('delete')){
      return (<DeleteIcon />)
    }
    else {
      return null;
    }
  };
  const handleColorDescription = (description: string, person: string, auditType: string, auditField: string) => {
    const indexOfFirstBracket = description.indexOf('[') + 1;
    const indexOfFirstEndBracket = description.indexOf(']') + 1;
    const toGetSecondSubString = description.slice(indexOfFirstEndBracket);
    const indexOfSecondBracket = (toGetSecondSubString).indexOf('[') + 1;
    const indexOfSecondEndBracket = (toGetSecondSubString).indexOf(']');
    let currAuditField = entityType.catalogAuditFields?.find((c:any)=>c.dbName===auditField)

    if (auditType.includes('New')) {
      const newValue = toGetSecondSubString.slice(indexOfSecondBracket, indexOfSecondEndBracket);
      let newValueString = newValue;
      return (
        <>
          <span style={{ fontWeight: 'bold' }}>{person}</span>
          <span>{` entered the `}</span>
          {currAuditField?.uiName}
          <span style={{ fontWeight: 'bold', color: '#006546' }}>{` ${newValueString}`}</span>
        </>
      )
    }
    else {
      const prevValue = description.slice(indexOfFirstBracket, indexOfFirstEndBracket - 1)
      const newValue = toGetSecondSubString.slice(indexOfSecondBracket, indexOfSecondEndBracket);

      let newValueString = newValue;
      let prevValueString = prevValue;
      return (
            <>
              <span style={{ fontWeight: 'bold' }}>{person}</span>
              <span>{` updated the `}</span>
              {currAuditField?.uiName}{' from '}
              <span style={{ fontWeight: 'bold', color: '#006546' }}>{` ${prevValueString} `}</span>
              <span>{`to `}</span>
              <span style={{ fontWeight: 'bold', color: '#006546' }}>{` ${newValueString} `}</span>

            </>

      )

    }
  }
  

  useEffect(()=>{
    location?.pathname && getAccessTokenCookie(`accessToken`) &&
    getAuditLogsCall();
  },[getAuditLogsCall, location?.pathname])

  const handleEndDate = (newValue: any) => {
    if (!isValidDate(newValue)) {
      setErrorEndDate('Invalid Date');
      return;
    }
    setEndDate(moment(newValue).utc().toDate());
    if ((moment(newValue) >= moment(startDate))) {
      if (errorStartDate === 'Invalid Date' || (moment() <= moment(startDate)) || (moment() <= moment(endDate)) || newValue === 'Invalid Date') {
        return
      }
      else {
        setErrorEndDate(null)
        setErrorStartDate(null)
      }
    }
    else if (moment(newValue) < moment(startDate)) {
      setErrorEndDate('End Date is before Start Date');
    }
    else {
      setErrorEndDate('Invalid Date');
    }
  }
  /* this will handle start date*/
  const handleStartDate = (newValue: any) => {
    if (!isValidDate(newValue)) {
      setErrorStartDate('Invalid Date');
      return;
    }
    setStartDate(moment(newValue).utc().toDate());
    if ((moment(newValue) <= moment(endDate))) {
      if (errorEndDate === 'Invalid Date' || (moment() <= moment(startDate)) || moment() <= moment(endDate) || newValue === 'Invalid Date') {
        return
      }

      else {
        setErrorEndDate(null)
        setErrorStartDate(null)
      }
    }
    else if (moment(newValue) > moment(endDate)) {
      setErrorStartDate('Start Date is after End Date');
    }
    else {
      setErrorStartDate('Invalid Date');
    }
  }

  const handleAllActivityChecked = () =>{
    if(allActivityChecked===false){
        setDisabledStartDate(true);
        setStartDate(moment('2000-01-01').utc().toDate());

    }
    else{
        setDisabledStartDate(false)
        setStartDate(moment().subtract(1, 'years').utc().toDate());
    }
    setAllActivityChecked(!allActivityChecked);
  };

  const handleChangePage = (
      event: React.MouseEvent<HTMLButtonElement> | null,
      newPage: number,
    ) => {
      setPage(newPage);
  };

    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      setRowsPerPage(Number.parseInt(event.target.value, 10));
      setPage(0);

    };

  return (
    <Box sx={{ flexShrink: 0, mb: 2 }}>
      <div
        style={{
          marginLeft: '1.5%',
          paddingTop: '2%',
          marginRight: '1.5%',
          paddingBottom: '1.5%',
          maxWidth: '100%',
        }}
      >
      <Box sx={{ boxShadow:'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: '5px', backgroundColor: 'white' }}>

            <Grid row gap="md" className='page-heading'>
                <Grid
                    desktop={{ col: 12 }}
                    className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
                </Grid>
            </Grid>
            <Grid row gap="md" style={{ marginLeft: '3rem', marginRight: '2rem', marginBottom: '1rem'}}>
                <div style={{ width: '25%' }}>
                    <label className="font-sans-md text-bold" htmlFor='activityStartDate'>Activity Start Date</label>
                </div>
                <div style={{ width: '25%' }}>
                    <label className="font-sans-md text-bold" htmlFor='activityEndDate'>Activity End Date </label>
                </div>
                <div style={{ width: '30%' }}>
                    <label className="font-sans-md text-bold" htmlFor='activityType'>Activity Type</label>
                </div>
                <div style={{ width: '20%' }}>
                  <FormControlLabel
                    label={<Typography style={{ fontSize: 'medium', fontWeight:700 }}>All Activity Checkbox</Typography>}
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
                    style={{ fontSize: '14px' }}
                    control={<Checkbox checked={allActivityChecked} onChange={handleAllActivityChecked} color="success" />}
                  />
                </div>
            </Grid>
            <Grid row gap="md" style={{ marginLeft: '3rem', marginRight: '2rem', marginBottom: '1rem'}}>
                <div style={{ width: '25%' }}>
                    <DatePicker
                        disableFuture
                        value={startDate}
                        slotProps={{
                            textField: {
                                error: errorStartDate ? true : false,
                                helperText: errorStartDate,
                                id: 'activityStartDate',
                            },

                        }}
                        disabled={disabledStartDate}
                        onError={(reason) => {
                            if (reason === 'disableFuture') {
                                setErrorStartDate('Start Date is in the Future');
                            }
                            else if (reason === 'invalidDate') {
                                setErrorStartDate('Invalid Date');
                            }
                            else if (reason === null && moment(startDate) <= moment(endDate)) {
                                setErrorStartDate(null);
                                setErrorEndDate(null);
                            }
                            else if (moment(startDate) > moment(endDate)) {
                                setErrorStartDate('Start Date is after End Date');
                            }
                            else {
                                setErrorStartDate('An Error on Start Date')
                            }
                        }}
                        onChange={(newValue) => { handleStartDate(newValue) }}
                    />
                </div>
                <div style={{ width: '25%' }}>
                    <DatePicker
                        value={endDate}
                        disableFuture
                        aria-labelledby='activityEndDate'

                        onError={(reason) => {
                            if (reason === 'disableFuture') {
                                setErrorEndDate('End Date is in the Future');
                            }
                            else if (reason === 'invalidDate') {
                                setErrorEndDate('Invalid Date');
                            }
                            else if (reason === null && moment(startDate) <= moment(endDate)) {
                                setErrorStartDate(null);
                                setErrorEndDate(null);
                            }
                            else if (moment(startDate) > moment(endDate)) {
                                setErrorEndDate('End Date is before End Date');
                            }
                            else {
                                setErrorStartDate('An Error on Start Date')
                            }
                        }}
                        slotProps={{
                            textField: {
                                error: errorEndDate ? true : false,
                                helperText: errorEndDate,
                                id: 'activityEndDate',

                            },
                        }}
                        onChange={(newValue) => handleEndDate(newValue)}
                    />
                </div>
                <div style={{ width: '25%' }}>
                    <Autocomplete
                        className="height-55"
                        
                        value={activityType}
                        aria-labelledby='activityType'
                        id="activityType"
                        onChange={(event: any, newValue: any) => {
                            setActivityType(newValue)
                        }}
                        disableClearable
                        options={(allActivityType)}
                        renderInput={(params) => (
                            <TextField
                                onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen, ValidCharacters.Comma)}
                                data-testid={'activityType'}
                                {...params}
                                label=""
                                InputProps={{
                                    ...params.InputProps,
                                    type: 'search',
                                }}
                            />
                        )}
                    />
                </div>
            </Grid>

            <Grid row gap="md">
                
                <Grid
                    desktop={{ col: 12 }}
                    className="smooth-scrollbar"
                    style={{ marginLeft: '3rem', marginRight: '2rem', maxHeight: '25rem', marginBottom: '2rem'}}
                >
                    <TableContainer component={Paper} className='margin-top-2 first-table MuiPaper-root-special'>

                        {/* TABLE FOR FUELS*/}
                        <Table
                            sx={{ minWidth: 200, minHeight: 100 }}
                        >
                            <colgroup>
                                <col width="20%"/>
                                <col width="60%"/>
                                <col width="20%"/>
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell tabIndex={0} className="headerParent2" >TYPE</TableCell>
                                    <TableCell tabIndex={0} className="headerParent2" >ACTIVITY</TableCell>
                                    <TableCell tabIndex={0} className="headerParent2" >ACTIVITY DATE</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    callAuditComplete? (
                                        auditItems?.length > 0 && auditItems.map((row, index) => {
                                            return (
                                                <TableRow key={row.id}>
                                                    <TableCell tabIndex={0}>{iconType(row.auditType)} {row.auditType}</TableCell>
                                                    <TableCell tabIndex={0}>{handleColorDescription(row.description, row.modifiedBy, row.auditType, row.auditField)}</TableCell>
                                                    <TableCell tabIndex={0}>{moment(row.modifiedTime).format('MM/DD/YY')}</TableCell>
        
                                                </TableRow>
                                            )
                                        })
                                    ):
                                    (
                                        <div style={{height: '200px'}}>
                                        <LoadingSpinner/>
                                      </div>
                                    )
                                }
                                {callAuditComplete && auditItems?.length < 1 &&
                                    <TableRow>
                                        <TableCell colSpan={3}>
                                            {message}
                                        </TableCell>
                                    </TableRow>
                                }

                            </TableBody>
                        </Table>
                              <CustomTablePagination
                                  rowsPerPageOptions={[10, 20, 30]}
                                  count={totalCount}
                                  page={page}
                                  rowsPerPage={rowsPerPage}
                                  onPageChange={handleChangePage}
                                  onChangeRowsPerPage={handleChangeRowsPerPage}
                              />   
                    </TableContainer>
                </Grid>
                
            </Grid>

        </Box>
      </div>
    </Box>

  );
}